<script setup lang="ts">
import { computed } from "vue";

import SVGWrapper from "./utils/SVGWrapper.vue";

import type { colorTag } from "@/Modules/App/Models/Styles/Colors";
import type { iconSize } from "@/Modules/App/Models/Styles/Icons";

export interface IconProps {
  size?: iconSize;
  color?: colorTag;
  background?: colorTag;
}

const props = withDefaults(defineProps<IconProps>(), { color: "content-high", size: "md" });

const colorClass = computed((): string => `fill-${props.color}`);
</script>

<template>
  <SVGWrapper :size="size" :background="background" viewBox="0 0 24 24">
    <path
      d="M2.37817 3C2.37817 2.72386 2.60203 2.5 2.87817 2.5L7.95594 2.50001C8.23208 2.50001 8.45594 2.72387 8.45594 3.00001C8.45594 3.27615 8.23208 3.50001 7.95594 3.50001L2.87817 3.5C2.60203 3.5 2.37817 3.27614 2.37817 3Z"
      :class="colorClass"
    />
    <path
      d="M2.37817 6C2.37817 5.72386 2.60203 5.5 2.87817 5.5L5.95594 5.50001C6.23208 5.50001 6.45594 5.72387 6.45594 6.00001C6.45594 6.27615 6.23208 6.50001 5.95594 6.50001L2.87817 6.5C2.60203 6.5 2.37817 6.27614 2.37817 6Z"
      :class="colorClass"
    />
    <path
      d="M2.87817 8.5C2.60203 8.5 2.37817 8.72386 2.37817 9C2.37817 9.27614 2.60203 9.5 2.87817 9.5L5.45594 9.50001C5.73208 9.50001 5.95594 9.27615 5.95594 9.00001C5.95594 8.72387 5.73208 8.50001 5.45594 8.50001L2.87817 8.5Z"
      :class="colorClass"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M12.9844 14.4744C13.5279 14.4744 14.0532 14.3965 14.5498 14.2514C16.5139 14.5803 17.8574 15.5574 18.7627 16.7007C19.8988 18.1356 20.3589 19.8545 20.4231 20.9356C20.4427 21.2664 20.7268 21.5187 21.0576 21.499C21.3884 21.4794 21.6406 21.1953 21.621 20.8645C21.5445 19.5766 21.0148 17.6121 19.7035 15.9558C18.8709 14.9043 17.7287 13.9855 16.2117 13.4449C17.6302 12.4351 18.5554 10.7772 18.5554 8.90332C18.5554 5.82652 16.0612 3.33228 12.9844 3.33228C9.90757 3.33228 7.41333 5.82652 7.41333 8.90332C7.41333 10.7837 8.34492 12.4465 9.77173 13.4553C8.22123 13.9955 7.06254 14.906 6.21913 15.9516C4.88038 17.6113 4.3617 19.5765 4.26257 20.8536C4.23693 21.184 4.48396 21.4726 4.81434 21.4983C5.14472 21.5239 5.43333 21.2769 5.45897 20.9465C5.54372 19.8546 5.99857 18.1364 7.15316 16.705C8.06414 15.5756 9.42738 14.6018 11.4552 14.2619C11.9411 14.4003 12.4541 14.4744 12.9844 14.4744ZM12.9844 13.2744C15.3984 13.2744 17.3554 11.3174 17.3554 8.90332C17.3554 6.48926 15.3984 4.53228 12.9844 4.53228C10.5703 4.53228 8.61333 6.48926 8.61333 8.90332C8.61333 11.3174 10.5703 13.2744 12.9844 13.2744Z"
      :class="colorClass"
    />
  </SVGWrapper>
</template>

<style scoped lang="scss"></style>
